import { render } from "./Defy.vue?vue&type=template&id=19e003d7"
import script from "./Defy.vue?vue&type=script&lang=js"
export * from "./Defy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\servers\\develope\\arbitrage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__